import { ReactNode } from "react";
import styled from "@emotion/styled";
import { Header } from "./typography/Header";
import Review from "./icons/Review";
import {
  StyledAccessBlockerButton,
  StyledAccessBlockerContainer,
} from "./layout/utils/desktop/components";
import { ParagraphMedium } from "./typography/Paragraph";
import { useNavigate } from "react-router";

const StyledHeader = styled(Header)`
  margin-bottom: 16px;
  font-size: 24px;
`;

const getAccessBlockerContent = (
  isWaitingForAttorneyBooking: boolean,
  isWaitingForAttorneyApproval: boolean,
): AccessBlockerContent => {
  if (isWaitingForAttorneyBooking) {
    return {
      icon: <Review />,
      title: "Waiting for Attorney Booking",
      description:
        "Notarization will be available after you have met with your attorney.",
      buttonLink: "/documents",
      buttonText: "View Document",
    };
  }

  if (isWaitingForAttorneyApproval) {
    return {
      icon: <Review />,
      title: "Waiting for Attorney Approval",
      description:
        "Notarization will be available after your attorney has approved the document.",
      buttonLink: "/documents",
      buttonText: "View Document",
    };
  }
  return {
    icon: <Review />,
    title: "🎉 All Set! Your Prenup is Notarized",
    description:
      "You've already crossed the finish line—your prenup is notarized and ready to go! That means no more edits can be made.",
    buttonLink: "/notarize",
    buttonText: "View Final Document",
  };
};

interface AccessBlockerContent {
  icon: ReactNode;
  title: string;
  description: string;
  buttonLink: string;
  buttonText: string;
}

const NotarizationAccessBlocker = ({
  isWaitingForAttorneyBooking = false,
  isWaitingForAttorneyApproval = false,
}) => {
  const content = getAccessBlockerContent(
    isWaitingForAttorneyBooking,
    isWaitingForAttorneyApproval,
  );
  const navigate = useNavigate();

  return (
    <StyledAccessBlockerContainer>
      {content.icon}
      <StyledHeader>{content.title}</StyledHeader>
      <ParagraphMedium fontWeight={300}>{content.description}</ParagraphMedium>
      <StyledAccessBlockerButton
        onClick={() => navigate(content.buttonLink)}
        aria-label={content.buttonText}
      >
        {content.buttonText}
      </StyledAccessBlockerButton>
    </StyledAccessBlockerContainer>
  );
};

export default NotarizationAccessBlocker;
